import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/trade/logoTrade.png'
import _imports_1 from '../assets/trade/tarjaAzul.jpg'
import _imports_2 from '../assets/trade/laptopTrade.png'
import _imports_3 from '../assets/trade/trade.png'
import _imports_4 from '../assets/home/logo_branco.svg'
import _imports_5 from '../assets/home/linkedin.png'


const _withScopeId = n => (_pushScopeId("data-v-dd6a5032"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "header",
  class: "flex column"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "logo",
    src: _imports_0,
    alt: "Logo"
  }),
  /*#__PURE__*/_createElementVNode("p", { id: "slogan" }, [
    /*#__PURE__*/_createTextVNode("Uma poderosa ferramenta de análise de tendências do "),
    /*#__PURE__*/_createElementVNode("span", { id: "slogan_Orange" }, " Setor Elétrico Brasileiro")
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tarja",
  src: _imports_1,
  alt: "Tarja"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "laptop",
    src: _imports_2,
    alt: "Laptop"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "info",
  class: "flex column"
}, [
  /*#__PURE__*/_createElementVNode("p", { id: "title" }, "LANÇAMENTO EM BREVE!"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "Logo"
  }),
  /*#__PURE__*/_createElementVNode("p", { id: "text" }, [
    /*#__PURE__*/_createTextVNode("O "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"#e94f37"} }, "Volty Trade"),
    /*#__PURE__*/_createTextVNode(" é uma ferramenta poderosa que permite aos operadores analisarem os diversos produtos negociados na BBCE, usando mais de 80 indicadores técnicos (Médias Móveis, Bolinger Band, MACD, IFR, ATR) e diversas ferramentas gráficas para análise de tendência (Candlestick, Heiken Ashi, Ondas de Elliott, Razões de Fibonacci e Gann). "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Tudo isso de forma fácil e eficiente."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Implantamos com sucesso o TradingView® e todas essas ferramentas já consagradas no mercado financeiro que podem ser utilizadas pelos operadores do mercado de energia. Basta ser agente da CCEE e possuir acesso à plataforma de negociações da BBCE que esta ferramenta estará habilitada para a sua empresa no Volty Trade.")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tarja",
  src: _imports_1,
  alt: "Tarja"
}, null, -1))
const _hoisted_6 = {
  id: "footer",
  class: "column flex items-center"
}
const _hoisted_7 = {
  id: "rodape",
  class: "row flex items-center"
}
const _hoisted_8 = { class: "divfoot row flex items-end" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"128px"},
  src: _imports_4,
  alt: "Logo"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  id: "email",
  style: {"color":"white"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bolder"} }, "E-mail"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("contato@studioapp.com.br")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divfoot2 column flex" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"end","margin-bottom":"40px"} }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.linkedin.com/company/studioapp/",
      target: "_blank"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        style: {"width":"36px","height":"36px"},
        src: _imports_5,
        alt: "Linkedin"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center column" }, [
    /*#__PURE__*/_createElementVNode("p", { style: {"color":"white"} }, "© studioApp - 2021 | Todos os direitos reservados")
  ])
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  id: "ad",
  style: {"text-decoration":"none","align-self":"end","margin-right":"3%"},
  href: "https://www.amaiscriacao.com.br/",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row flex" }, [
    /*#__PURE__*/_createElementVNode("p", { style: {"color":"white","margin-right":"5px","font-size":"10px"} }, "Designed by"),
    /*#__PURE__*/_createElementVNode("img", {
      style: {"width":"20px","height":"12px"},
      src: "https://static.wixstatic.com/media/dea8ea_9a6a9b63390345b8a17dfd74e3f4ab09.png/v1/fill/w_79,h_46,al_c,q_85,usm_0.66_1.00_0.01/dea8ea_9a6a9b63390345b8a17dfd74e3f4ab09.webp"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    id: "body",
    class: "column no-wrap"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/'))),
              style: {"cursor":"pointer"}
            }, _hoisted_10),
            _hoisted_11
          ]),
          _createVNode(_component_q_space),
          _hoisted_12
        ]),
        _hoisted_13
      ])
    ]),
    _: 1
  }))
}